<template>
  <EditarBase
    :itemAtual="itemAtual"
    :recursoInicial="recursoInicial"
    nomeSingular="ModeloDocumentacaoAcessoria"
    nomePlural="ModeloDocumentacaoAcessorias"
    @recurso="recurso = $event"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <span class="opacity-5 text-dark">
            {{ $t("Descricao") }}
          </span>
          <v-text-field
            v-model="recurso.descricao"
            :label="$t('Descricao')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-checkbox v-model="recurso.impressaoComCabecalho">
            <template v-slot:label>
              {{ $t("impressaoComCabecalho") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox v-model="recurso.impressaoSemCabecalho">
            <template v-slot:label>
              {{ $t("impressaoSemCabecalho") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox
            v-model="recurso.geracaoAutomaticaAdmissaoPrazoIndeterminado"
          >
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdmissaoPrazoIndeterminado") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox
            v-model="recurso.geracaoAutomaticaAdmissaoPrazoDeterminado"
          >
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdmissaoPrazoDeterminado") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAdmissaoIntermitente">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdmissaoIntermitente") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAvisoPrevioIndenizado">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAvisoPrevioIndenizado") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAvisoPrevioTrabalhado">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAvisoPrevioTrabalhado") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaFerias">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaFerias") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaFeriasAbono">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaFeriasAbono") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaSuspensao">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaSuspensao") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAdvertencia">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdvertencia") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox
            v-model="recurso.geracaoAutomaticaMovimentacaoPostoTrabalho"
          >
            <template v-slot:label>
              {{ $t("geracaoAutomaticaMovimentacaoPostoTrabalho") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoRomaneioUniforme">
            <template v-slot:label>
              {{ $t("geracaoRomaneioUniforme") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="12">
          <AjudaVariaveisTexto :definicao="variaveisTexto" />
          <span class="opacity-5 text-dark">
            {{ $t("Texto") }}
          </span>
          <v-textarea
            v-model="recurso.texto"
            :label="$t('Texto')"
            :payload="recurso.texto"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-textarea>
        </v-col>
      </v-row>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import AjudaVariaveisTexto from "@/components/base/proprios/AjudaVariaveisTexto";
import variaveisTexto from "./variaveisModeloDocumentacaoAcessoria";

import ModeloDocumentacaoAcessoriaDataService from "@/services/pessoal/ModeloDocumentacaoAcessoriaDataService";
const DataService = ModeloDocumentacaoAcessoriaDataService;

export default {
  props: {
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
  },
  name: "EditarModeloDocumentacaoAcessoria",
  components: { EditarBase, AjudaVariaveisTexto },
  data() {
    return {
      DataService: DataService,
      submited: false,

      recurso: {},
      variaveisTexto,
      errors: [],

      itensStatusComum: [
        { text: this.$t("Ativo"), value: "ATIVO" },
        { text: this.$t("Inativo"), value: "INATIVO" },
      ],
    };
  },

  computed: {},

  mounted() {
    //this.getRecurso();
  },

  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    getRecurso() {
      DataService.find(this.recurso.id)
        .then((response) => {
          this.recurso.id = response.data.id;
          this.recurso.salarioBase = response.data.salarioBase;
          this.recurso.descricao = response.data.descricao;
          this.recurso.statusComum = response.data.statusComum;
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
          this.errors.push({ field: "ID", message: "Usuário não encontrado" });
        });
    },
  },
};
</script>

<style scoped></style>
